import {Controller} from "stimulus";

export default class extends Controller {

    connect() {
    }

    initialize() {
        $('#form-request-error').hide();
        this.url = this.data.get('url');
    }

    submitForm(submitEvent) {
        submitEvent.preventDefault();

        let container = $("#request-form-global");
        let formData = [];

        if (container) {
            $('#form-request-error').hide();
            let form = $('form', container);
            $('#request_modal_btn').removeAttr('disabled');
            if (this.checkForRequiredField(form)) {
                formData = new FormData(form[0]);

                let _self = this;
                $('.global-loader').show();
                $.ajax({
                    url: _self.url,
                    data: formData,
                    method: 'POST',
                    processData: false,
                    contentType: false,
                    success: function (response) {
                        $('.global-loader').hide();
                        var success = response.success;
                        if (success) {
                            $('#form-request-alert').show();
                            $('#request_modal_btn').hide();
                            setTimeout(function (){
                                $("#send-request").modal('hide')
                                $('#form-request-alert').hide();
                                $('#request_modal_btn').show();
                            }, 5000)
                        }

                    },
                    error: function (error) {
                        $('#form-request-alert').hide();
                    }
                });
                submitEvent.returnValue = true;

            }
        }
    }

    showErrorText(errorText){
        $('#form-request-error .alert').text(errorText);
        $('#form-request-error').show();
    }
    checkForRequiredField(form){
        console.log(form);
        let _self = this;
        var isValid = true;
        form.find('.required').each(function (key,element){
            var elementType = $(element).attr('type');
            if(elementType === 'text' || elementType === 'email'){
                if ($(element).val() === '') {
                    _self.showErrorText($(element).data('error-message'));
                    isValid = false;
                }
            }
            if(elementType === 'checkbox' && isValid){
                if(!$(element).is(':checked')){
                    _self.showErrorText($(element).data('error-message'));
                    isValid = false;
                }
            }
        });

        return isValid;
    }
}

